<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "MasterUjoIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
